import { Alert, Typography } from "@mui/material";
import { MyDeviceModalItemSection } from "src/components/DeviceCreation/modal-list-items/MyDeviceModalComponents/MyDeviceModalItemSection";

export const FreePlanLimitModalItemContent = () => {
  return (
    <MyDeviceModalItemSection>
      <Typography variant="h6">Device limit reached</Typography>
      <Alert severity="warning">
        The free plan allows you to create only one device. Please upgrade to a
        paid plan to create additional devices.
      </Alert>
    </MyDeviceModalItemSection>
  );
};
